// reducers/demoRequestReducer.js
import {
  SUBMIT_DEMO_REQUEST,
  SUBMIT_DEMO_SUCCESS,
  SUBMIT_DEMO_FAILURE,
} from "../actions/demoRequestActions";

const initialState = {
  loading: false,
  successMessage: null,
  errorMessage: null,
};

const demoRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_DEMO_REQUEST:
      return {
        ...state,
        loading: true,
        successMessage: null,
        errorMessage: null,
      };
    case SUBMIT_DEMO_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload,
        errorMessage: null,
      };
    case SUBMIT_DEMO_FAILURE:
      return {
        ...state,
        loading: false,
        successMessage: null,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

export default demoRequestReducer;
